/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum EmailSenderOption {
    ORDER_CONFIRMATION = 'order_confirmation',
    READY_TO_COLLECT = 'ready_to_collect',
    THANK_YOU = 'thank_you',
    WITH_TAILOR = 'with_tailor',
}
